import { Center, Grid, Text } from "@mantine/core";
import { ProjectCard } from "components/project/OldProjectCards/ProjectCard";
import { useMobile } from "shared/hooks/useMobile";
import { Project } from "shared/types/projects";

export const ProjectCards = ({ projects }: { projects: Project[] }) => {
  const { setOption } = useMobile();

  if (!projects.length) {
    return (
      <Center>
        <Text>Нет проектов по заданным параметрам</Text>
      </Center>
    );
  }

  return (
    <Grid>
      {projects.map((item, index) => (
        <Grid.Col key={index} span={setOption(12, 4)}>
          <ProjectCard {...item} />
        </Grid.Col>
      ))}
    </Grid>
  );
};
